import { useLocation } from 'react-router-dom';

export const getPaginate = (value: string = 'paginate') => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paginate = queryParams.get(value);

  const paginateObj = { value, paginate: paginate ? Number(paginate) : 1 };

  return paginateObj;
};

export const getParams = (title: string) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const params = queryParams.get(title);

  const paramsObj = { title, value: params || '' };

  return paramsObj;
};
